import { __assign } from "tslib";
import React from 'react';
import classNames from 'classnames';
import styles from './icon-button.module.css';
import { colourString } from '../../../library';
export function IconButton(_a) {
    var _b;
    var _c = _a.hoverTone, hoverTone = _c === void 0 ? 'secondary' : _c, _d = _a.borderRadius, borderRadius = _d === void 0 ? '0px' : _d, _e = _a.borderWidth, borderWidth = _e === void 0 ? 1 : _e, _f = _a.borderColour, borderColour = _f === void 0 ? 'none' : _f, _g = _a.disableHoverEffect, disableHoverEffect = _g === void 0 ? false : _g, _h = _a.backgroundColour, backgroundColour = _h === void 0 ? 'none' : _h, _j = _a.padding, padding = _j === void 0 ? 10 : _j, children = _a.children, onClick = _a.onClick, disabled = _a.disabled, iconType = _a.iconType, className = _a.className;
    if (!children && process.env.NODE_ENV !== 'production')
        throw new Error("<IconButton>: Requires a JSX.Element child.");
    function onClickHandler(event) {
        if (disabled || !onClick)
            return;
        onClick(event);
    }
    var variables = {
        '--icon-fill-colour': 'none',
        '--icon-stroke-colour': 'none',
        padding: "".concat(padding, "px"),
        borderRadius: borderRadius,
        border: "".concat(borderWidth, "px solid ").concat(colourString(borderColour)),
        background: backgroundColour === 'none' ? 'none' : colourString(backgroundColour),
    };
    if (!disableHoverEffect) {
        variables = __assign(__assign({}, variables), { '--icon-fill-colour': iconType === 'stroke' ? 'none' : colourString(hoverTone), '--icon-stroke-colour': iconType === 'fill' ? 'none' : colourString(hoverTone) });
    }
    if (disabled) {
        variables = __assign(__assign({}, variables), { '--icon-fill-colour': iconType === 'stroke' ? 'none' : colourString('default'), '--icon-stroke-colour': iconType === 'fill' ? 'none' : colourString('default') });
    }
    return (React.createElement("button", { style: variables, className: classNames(styles.iconButtonWrapper, (_b = {}, _b[styles.disabled] = disabled, _b[styles.disableHoverEffect] = disableHoverEffect, _b), className, "kplr_iconButtonWrapper"), onClick: function (event) { return onClickHandler(event); } }, children));
}
export default IconButton;
